import register from 'ShopUiBundle/modules/app/registry';
import './range-slider.scss';

// tslint:disable-next-line
register('range-slider', () => import(/* webpackMode: "lazy" */'./range-slider'));
